import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  // 기본 컨테이너
  container: {
    flex: 1,
    backgroundColor: '#f5f5f5',
  },
  
  // 에러 배너
  errorBanner: {
    backgroundColor: '#ff4757',
    padding: 12,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  errorText: {
    color: '#fff',
    fontSize: 14,
    flex: 1,
  },
  errorClose: {
    color: '#fff',
    fontSize: 18,
    paddingLeft: 12,
  },
  
  // 스크롤 영역
  scrollView: {
    flex: 1,
  },
  
  // 콘텐츠 영역
  content: {
    padding: 16,
  },
  
  // 로딩
  loadingContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 400,
  },
  loadingText: {
    fontSize: 14,
    marginTop: 16,
    color: '#666',
  },
  
  // 헤더 섹션
  headerSection: {
    backgroundColor: '#fff',
    borderRadius: 8,
    padding: 16,
    marginBottom: 16,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.05,
    shadowRadius: 2,
    elevation: 2,
  },
  headerContent: {
    flexDirection: 'column',
    gap: 12,
  },
  pageTitle: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#1a1a1a',
    marginBottom: 4,
  },
  pageSubtitle: {
    fontSize: 14,
    color: '#666',
  },
  refreshButton: {
    backgroundColor: '#1890ff',
    paddingHorizontal: 16,
    paddingVertical: 8,
    borderRadius: 4,
    alignSelf: 'flex-start',
  },
  refreshText: {
    color: '#fff',
    fontSize: 14,
    fontWeight: '500',
  },
  
  // 상태 개요 섹션
  overviewSection: {
    marginBottom: 16,
  },
  overviewGrid: {
    gap: 16,
  },
  overviewCard: {
    backgroundColor: '#fff',
    borderRadius: 8,
    padding: 16,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.05,
    shadowRadius: 2,
    elevation: 2,
  },
  overviewCardHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 12,
    paddingBottom: 12,
    borderBottomWidth: 1,
    borderBottomColor: '#f0f0f0',
  },
  overviewCardTitle: {
    fontSize: 16,
    fontWeight: '600',
    color: '#333',
  },
  statusIndicator: {
    paddingHorizontal: 10,
    paddingVertical: 3,
    borderRadius: 10,
  },
  statusIndicatorText: {
    color: '#fff',
    fontSize: 12,
    fontWeight: '500',
  },
  overviewCardBody: {
    gap: 12,
  },
  overviewInfo: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  overviewLabel: {
    fontSize: 13,
    color: '#666',
  },
  overviewValue: {
    fontSize: 14,
    fontWeight: '500',
    color: '#1a1a1a',
  },
  nextRunTime: {
    fontSize: 16,
    fontWeight: '600',
    color: '#1890ff',
    marginBottom: 16,
    textAlign: 'center',
  },
  syncButton: {
    backgroundColor: '#1890ff',
    paddingVertical: 10,
    borderRadius: 4,
    alignItems: 'center',
  },
  syncButtonDisabled: {
    backgroundColor: '#d9d9d9',
  },
  syncButtonText: {
    color: '#fff',
    fontSize: 14,
    fontWeight: '600',
  },
  
  // 실행 이력 섹션
  historySection: {
    backgroundColor: '#fff',
    borderRadius: 8,
    padding: 16,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.05,
    shadowRadius: 2,
    elevation: 2,
  },
  sectionHeader: {
    marginBottom: 16,
    paddingBottom: 12,
    borderBottomWidth: 1,
    borderBottomColor: '#f0f0f0',
  },
  sectionTitle: {
    fontSize: 18,
    fontWeight: '600',
    color: '#333',
  },
  
  // 테이블 (모바일에서는 리스트 형태)
  historyTable: {
    gap: 12,
  },
  tableHeader: {
    display: 'none' as any, // 모바일에서는 헤더 숨김
  },
  tableHeaderCell: {
    display: 'none' as any,
  },
  tableRow: {
    backgroundColor: '#f8f8f8',
    borderRadius: 8,
    padding: 12,
    gap: 8,
  },
  tableCell: {
    fontSize: 13,
    color: '#333',
  },
  colDate: {
    marginBottom: 4,
  },
  colStatus: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 4,
  },
  colRecords: {
    flexDirection: 'row',
  },
  colDuration: {
    flexDirection: 'row',
  },
  statusBadge: {
    paddingHorizontal: 8,
    paddingVertical: 2,
    borderRadius: 4,
    alignSelf: 'flex-start',
  },
  statusBadgeText: {
    color: '#fff',
    fontSize: 12,
    fontWeight: '500',
  },
  
  // 빈 상태
  emptyState: {
    padding: 40,
    alignItems: 'center',
  },
  emptyStateText: {
    fontSize: 14,
    color: '#999',
  },
  
  // 페이지네이션
  pagination: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 16,
    paddingTop: 16,
    borderTopWidth: 1,
    borderTopColor: '#f0f0f0',
    gap: 12,
  },
  pageButton: {
    paddingVertical: 6,
    paddingHorizontal: 16,
    backgroundColor: '#f0f0f0',
    borderRadius: 4,
  },
  pageButtonDisabled: {
    opacity: 0.5,
  },
  pageButtonText: {
    fontSize: 14,
    color: '#333',
  },
  pageInfo: {
    fontSize: 14,
    color: '#666',
  },
});